import { render, staticRenderFns } from "./SearchDrugPage.vue?vue&type=template&id=3947ada6&scoped=true&"
import script from "./SearchDrugPage.vue?vue&type=script&lang=js&"
export * from "./SearchDrugPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchDrugPage.vue?vue&type=style&index=0&id=3947ada6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3947ada6",
  null
  
)

export default component.exports